// Styles — Parcel will extract these into a CSS bundle
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import $ from 'jquery';
import 'popper.js';
import 'bootstrap';
import registerHerbyCookie from './herbyCookie';
import intercomLoader from './intercomLoader';
import hideLoader from './hideLoader';

hideLoader();
intercomLoader();

// Make jQuery available globally for inline scripts and future plugins
window.$ = $;
window.jQuery = $;

registerHerbyCookie($);

$(document).ready(function () {
  // Mobile submenu toggle (shared header's Industries dropdown)
  $(document).on('click', '.submenu-toggle-btn', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $submenu = $(this).closest('.dropdown-submenu');
    const isOpen = $submenu.hasClass('submenu-open');
    $submenu.toggleClass('submenu-open', !isOpen);
    $(this).attr('aria-expanded', String(!isOpen));
  });

  $(document).herbyCookie({
    heading: 'We use cookies',
    text: 'We use cookies to ensure you get the best experience on our website. By continuing to browse, you agree to our',
    policyText: 'Privacy Policy',
    link: 'https://policies.swirepay.com/',
    btnText: 'Accept All',
    expireDays: 30,
    scroll: false,
  });

  // Support hero — swap eyebrow/heading/subtext to match the selected option card
  $(document).on('click', '[data-hero-option]', function () {
    const $option = $(this);
    const $content = $('[data-hero-content]');

    $('[data-hero-option]').removeClass('is-active').attr('aria-selected', 'false');
    $option.addClass('is-active').attr('aria-selected', 'true');

    $content.css('--eyebrow-color', $option.data('eyebrow-color'));
    $('[data-hero-eyebrow]', $content).text($option.data('eyebrow'));
    $('[data-hero-heading]', $content).text($option.data('heading'));
    $('[data-hero-subtext]', $content).text($option.data('subtext'));

    // Show the main-panel content that matches the selected tab
    const panel = $option.data('panel');
    $('[data-panel-content]').prop('hidden', true);
    $(`[data-panel-content="${panel}"]`).prop('hidden', false);
  });

  // "Talk to Sales" (inside the Getting started panel) — jumps to the Sales & enquiry tab
  $(document).on('click', '[data-goto-panel]', function () {
    $(`[data-hero-option][data-panel="${$(this).data('goto-panel')}"]`).trigger('click');
  });

  initPhoneMasks();
  initSupportTicketForm();
  initSalesEnquiryForm();
});

// ── Attachment upload (support ticket form) ────────────────────────────────
const ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;
const ATTACHMENT_ALLOWED_EXTENSIONS = ['png', 'jpg', 'jpeg', 'pdf', 'txt'];
const ATTACHMENT_ALLOWED_MIME_TYPES = ['image/png', 'image/jpeg', 'application/pdf', 'text/plain'];
const attachmentPresignUrl = process.env.SUPPORT_TICKET_ATTACHMENT_PRESIGN_URL;

function validateAttachment(file) {
  const extension = (file.name.split('.').pop() || '').toLowerCase();
  const extensionAllowed = ATTACHMENT_ALLOWED_EXTENSIONS.includes(extension);
  const mimeAllowed = !file.type || ATTACHMENT_ALLOWED_MIME_TYPES.includes(file.type);

  if (!extensionAllowed || !mimeAllowed) {
    return 'File type not supported. Upload a PNG, JPG, JPEG, PDF, or TXT file.';
  }
  if (file.size > ATTACHMENT_MAX_BYTES) {
    return 'File is too large. Attachments must be 10 MB or smaller.';
  }
  return '';
}

// Asks the backend for a pre-signed S3 PUT URL for this file, then uploads
// the file straight to S3 with it. Resolves with the S3 path the backend
// wants back on the ticket submission payload.
function uploadAttachment(file) {
  return fetch(attachmentPresignUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      fileName: file.name,
      contentType: file.type || 'application/octet-stream',
      fileSize: file.size,
    }),
  })
    .then(res => {
      if (!res.ok) throw new Error('Could not get an upload URL');
      return res.json();
    })
    .then(({ uploadUrl, path }) =>
      fetch(uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': file.type || 'application/octet-stream' },
        body: file,
      }).then(res => {
        if (!res.ok) throw new Error('Upload failed');
        return path;
      })
    );
}

function initAttachmentUpload($form) {
  const $dropzone = $('[data-dropzone]', $form);
  if (!$dropzone.length) return;

  const $input = $('[data-attachment-input]', $dropzone);
  const $prompt = $('[data-dropzone-prompt]', $dropzone);
  const $fileRow = $('[data-dropzone-file]', $dropzone);
  const $fileName = $('[data-dropzone-file-name]', $dropzone);
  const $fileStatus = $('[data-dropzone-file-status]', $dropzone);
  const $errorMsg = $('#ticketAttachment-error-msg');

  function resetAttachment() {
    $form.data('attachmentPath', null);
    $form.data('attachmentUploading', false);
    $input.val('');
    $fileRow.prop('hidden', true);
    $prompt.prop('hidden', false);
    $dropzone.removeClass('is-invalid');
    $errorMsg.text('');
  }

  function handleFile(file) {
    if (!file) return;

    $dropzone.removeClass('is-invalid');
    $errorMsg.text('');

    const validationError = validateAttachment(file);
    if (validationError) {
      $input.val('');
      $dropzone.addClass('is-invalid');
      $errorMsg.text(validationError);
      return;
    }

    $form.data('attachmentPath', null);
    $form.data('attachmentUploading', true);

    $prompt.prop('hidden', true);
    $fileRow.prop('hidden', false);
    $fileName.text(file.name);
    $fileStatus.removeClass('is-error is-success').html('<span class="spinner spinner--sm"></span> Uploading…');

    uploadAttachment(file)
      .then(path => {
        $form.data('attachmentPath', path);
        $form.data('attachmentUploading', false);
        $fileStatus.removeClass('is-error').addClass('is-success').text('Uploaded');
      })
      .catch(() => {
        $form.data('attachmentUploading', false);
        $fileStatus.removeClass('is-success').addClass('is-error').text('Upload failed — remove and try again.');
      });
  }

  $dropzone.on('click', function (e) {
    // The browse label already opens the picker natively, and the remove
    // button has its own handler — don't also trigger the input for those.
    if ($(e.target).closest('[data-dropzone-file-remove], .support-ticket-form__browse').length) return;
    if (!$fileRow.is(':hidden')) return;
    $input.trigger('click');
  });

  $input.on('change', function () {
    handleFile(this.files && this.files[0]);
  });

  $dropzone.on('dragover dragenter', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if ($fileRow.is(':hidden')) $dropzone.addClass('is-dragover');
  });

  $dropzone.on('dragleave dragend', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $dropzone.removeClass('is-dragover');
  });

  $dropzone.on('drop', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $dropzone.removeClass('is-dragover');
    if (!$fileRow.is(':hidden')) return;

    const file = e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.files[0];
    if (file) handleFile(file);
  });

  $(document).on('click', '[data-dropzone-file-remove]', function (e) {
    e.preventDefault();
    e.stopPropagation();
    resetAttachment();
  });
}

// ── Support ticket form ───────────────────────────────────────────────────────
function getActiveRegion() {
  return $('[data-region-btn].is-active').data('region-btn') || 'US';
}

const PHONE_MAX_DIGITS = 10;

// Formats a digits-only national number for display, per the selected country code.
// Only ever called with a string that's already been stripped to [0-9].
function formatNationalNumber(digits, countryCode) {
  if (!digits) return '';
  if (countryCode === '+1') {
    let out = '(' + digits.slice(0, 3);
    if (digits.length >= 3) out += ') ';
    out += digits.slice(3, 6);
    if (digits.length >= 6) out += '-';
    out += digits.slice(6, 10);
    return out;
  }
  let out = digits.slice(0, 5);
  if (digits.length > 5) out += ' ' + digits.slice(5, 10);
  return out;
}

function countDigitsBefore(value, index) {
  let count = 0;
  for (let i = 0; i < index; i++) {
    if (/\d/.test(value[i])) count++;
  }
  return count;
}

// Finds the caret position in `formatted` that sits right after the Nth digit.
function caretAfterDigit(formatted, digitCount) {
  if (digitCount <= 0) return 0;
  let seen = 0;
  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted[i])) {
      seen++;
      if (seen === digitCount) return i + 1;
    }
  }
  return formatted.length;
}

// Phone mask — shared by any [data-phone-group] wrapper containing a
// [data-phone-country-code] select and a [data-phone-input] text field
// (currently the support-ticket and sales-enquiry forms). Rather than diffing
// old vs. new text (fragile across punctuation boundaries), this recomputes
// the caret position from the number of digits before it on every keystroke —
// so typed letters never enter the digit buffer, and backspace/delete always
// removes an actual digit even when the character the browser just erased was
// a mask character (space, "(", ")", "-"), instead of getting stuck against it.
function initPhoneMasks() {
  // Country code — reformats the phone field's existing digits for the new mask
  $(document).on('change', '[data-phone-country-code]', function () {
    const countryCode = $(this).val();
    const $phone = $(this).closest('[data-phone-group]').find('[data-phone-input]');

    $phone.attr('placeholder', countryCode === '+1' ? '(555) 000-0000' : '98765 43210');

    const digits = ($phone.data('phoneDigits') || '').slice(0, PHONE_MAX_DIGITS);
    $phone.val(formatNationalNumber(digits, countryCode));
    $phone.data('phoneDigits', digits);
  });

  $(document).on('input', '[data-phone-input]', function (e) {
    const input = this;
    const $input = $(input);
    const countryCode = $input.closest('[data-phone-group]').find('[data-phone-country-code]').val() || '+1';
    const caret = input.selectionStart;

    let digitsBeforeCaret = countDigitsBefore(input.value, caret);
    let digits = input.value.replace(/\D/g, '').slice(0, PHONE_MAX_DIGITS);
    digitsBeforeCaret = Math.min(digitsBeforeCaret, digits.length);

    const prevDigitCount = $input.data('phoneDigitCount');
    const inputType = e.originalEvent && e.originalEvent.inputType;

    // The edit landed on a mask character, not a digit — the digit count is
    // unchanged, so manually drop the digit next to the caret ourselves.
    if (prevDigitCount !== undefined && digits.length === prevDigitCount) {
      if (inputType === 'deleteContentBackward' && digitsBeforeCaret > 0) {
        digits = digits.slice(0, digitsBeforeCaret - 1) + digits.slice(digitsBeforeCaret);
        digitsBeforeCaret -= 1;
      } else if (inputType === 'deleteContentForward' && digitsBeforeCaret < digits.length) {
        digits = digits.slice(0, digitsBeforeCaret) + digits.slice(digitsBeforeCaret + 1);
      }
    }

    const formatted = formatNationalNumber(digits, countryCode);
    input.value = formatted;
    const newCaret = caretAfterDigit(formatted, digitsBeforeCaret);
    input.setSelectionRange(newCaret, newCaret);

    $input.data('phoneDigits', digits);
    $input.data('phoneDigitCount', digits.length);
  });
}

// Disables the submit button, shows a spinner, then POSTs the payload to
// `endpoint`, showing a success or failure state before re-enabling the
// button. Shared by the ticket and sales enquiry forms.
function submitFormPayload($submitBtn, endpoint, payload, successLabel) {
  const originalLabel = $submitBtn.text();
  const $spinner = $('<span>').addClass('ml-2 spinner spinner--white spinner--sm');
  $submitBtn.prop('disabled', true).text('Submitting').append($spinner);

  // console.log(payload);
  //
  // setTimeout(() => {
  //   const $tick = $('<i>').attr('data-lucide', 'check').addClass('ml-2').attr('style', 'width: 18px; height: 18px;');
  //   $submitBtn.text(successLabel).append($tick);
  //   if (window.lucide) window.lucide.createIcons();
  //
  //   setTimeout(() => {
  //     $submitBtn.prop('disabled', false).text(originalLabel);
  //   }, 4000);
  // }, 1500);

  fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
    .then(res => {
      if (!res.ok) throw new Error('Could not submit');

      const $tick = $('<i>').attr('data-lucide', 'check').addClass('ml-2').attr('style', 'width: 18px; height: 18px;');
      $submitBtn.text(successLabel).append($tick);
      if (window.lucide) window.lucide.createIcons();
    })
    .catch(() => {
      const $cross = $('<i>').attr('data-lucide', 'x').addClass('ml-2').attr('style', 'width: 18px; height: 18px;');
      $submitBtn.text('Submission failed').append($cross);
      if (window.lucide) window.lucide.createIcons();
    })
    .finally(() => {
      setTimeout(() => {
        $submitBtn.prop('disabled', false).text(originalLabel);
      }, 4000);
    });
}

function initSupportTicketForm() {
  const $form = $('#supportTicketForm');
  if (!$form.length) return;

  initAttachmentUpload($form);

  // Support region toggle — routing only; the phone mask is driven solely by
  // the country-code dropdown below, not by this selection.
  $(document).on('click', '[data-region-btn]', function () {
    const region = $(this).data('region-btn');

    $('[data-region-btn]').removeClass('is-active').attr('aria-pressed', 'false');
    $(this).addClass('is-active').attr('aria-pressed', 'true');

    $('[data-region-hint]').text(
      region === 'US'
        ? 'United States is selected by default. Choose India to route the request to the India support team.'
        : 'India is selected. Your request will be routed to the India support team.'
    );
  });

  // Category selection (single-select cards)
  $(document).on('click', '[data-category]', function () {
    $('[data-category]').removeClass('is-active');
    $(this).addClass('is-active');
    $('#ticketCategory-error-msg').text('');
  });

  // Critical impact banner
  $(document).on('change', '[data-business-impact]', function () {
    $('[data-critical-alert]').prop('hidden', $(this).val() !== 'critical');
  });

  // Live description character counter
  $(document).on('input', '#ticketDescription', function () {
    $('[data-char-count]').text(`${$(this).val().length}/2500 characters`);
  });

  // Submit — validates, then simulates an async submission (no API call yet)
  $form.on('submit', function (e) {
    e.preventDefault();

    const $submitBtn = $('#ticketSubmitBtn');
    if ($submitBtn.prop('disabled')) return;

    $form.addClass('was-validated');

    const region = getActiveRegion();
    const firstName = $('#ticketFirstName').val().trim();
    const lastName = $('#ticketLastName').val().trim();
    const email = $('#ticketEmail').val().trim();
    const countryCode = $('#ticketPhoneCountryCode').val() || '+1';
    const phoneDigits = ($('#ticketPhone').data('phoneDigits') || '').slice(0, PHONE_MAX_DIGITS);
    const businessName = $('#ticketBusinessName').val().trim();
    const merchantId = $('#ticketMerchantId').val().trim();
    const $activeCategory = $('[data-category].is-active');
    const category = $activeCategory.data('category') || '';
    const issueType = $('#ticketIssueType').val();
    const businessImpact = $('#ticketBusinessImpact').val();
    const subject = $('#ticketSubject').val().trim();
    const description = $('#ticketDescription').val().trim();
    const transactionId = $('#ticketTransactionId').val().trim();
    // <input type="datetime-local">'s value has no timezone — the browser only
    // ever hands back a local wall-clock string. Interpreting it as the
    // browser's own local time and converting to ISO attaches an unambiguous
    // UTC offset before it goes in the payload.
    const incidentDateLocal = $('#ticketIncidentDate').val();
    const incidentDate = incidentDateLocal ? new Date(incidentDateLocal).toISOString() : null;

    let isValid = true;
    const setFieldError = (fieldId, msg, $el) => {
      $(`#${fieldId}-error-msg`).text(msg || '');
      if ($el) $el.toggleClass('is-invalid', !!msg);
      if (msg) isValid = false;
    };

    setFieldError('ticketFirstName', firstName ? '' : 'First name is required.', $('#ticketFirstName'));
    setFieldError('ticketLastName', lastName ? '' : 'Last name is required.', $('#ticketLastName'));

    if (!email) {
      setFieldError('ticketEmail', 'Work email is required.', $('#ticketEmail'));
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setFieldError('ticketEmail', 'Enter a valid email address (e.g. name@company.com).', $('#ticketEmail'));
    } else {
      setFieldError('ticketEmail', '', $('#ticketEmail'));
    }

    if (phoneDigits) {
      setFieldError(
        'ticketPhone',
        phoneDigits.length === PHONE_MAX_DIGITS ? '' : `Enter a valid ${countryCode === '+1' ? 'US' : 'India'} phone number.`,
        $('#ticketPhone')
      );
    } else {
      setFieldError('ticketPhone', '', $('#ticketPhone'));
    }

    setFieldError('ticketBusinessName', businessName ? '' : 'Business name is required.', $('#ticketBusinessName'));

    if (!category) {
      $('#ticketCategory-error-msg').text('Choose a category.');
      isValid = false;
    } else {
      $('#ticketCategory-error-msg').text('');
    }

    setFieldError('ticketIssueType', issueType ? '' : 'Select an issue type.', $('#ticketIssueType'));
    setFieldError('ticketSubject', subject ? '' : 'Subject is required.', $('#ticketSubject'));

    if (!description) {
      setFieldError('ticketDescription', 'Description is required.', $('#ticketDescription'));
    } else if (description.length < 10) {
      setFieldError('ticketDescription', 'Please provide at least 10 characters describing the issue.', $('#ticketDescription'));
    } else {
      setFieldError('ticketDescription', '', $('#ticketDescription'));
    }

    if ($form.data('attachmentUploading')) {
      $('#ticketAttachment-error-msg').text('Please wait for the attachment to finish uploading.');
      isValid = false;
    }

    if (!isValid) return;

    const payload = {
      payloadType: 'SWIREPAY_SUPPORT_TICKET',
      region,
      firstName,
      lastName,
      email,
      phone: phoneDigits ? `${countryCode}${phoneDigits}` : null,
      businessName,
      merchantId: merchantId || null,
      category,
      issueType,
      businessImpact,
      subject,
      description,
      transactionId: transactionId || null,
      incidentDate,
      attachmentPath: $form.data('attachmentPath') || null,
    };

    submitFormPayload($submitBtn, process.env.SUPPORT_TICKET_SUBMIT, payload, 'Ticket submitted');
  });
}

function initSalesEnquiryForm() {
  const $form = $('#salesEnquiryForm');
  if (!$form.length) return;

  // Topic selection (single-select pills)
  $(document).on('click', '[data-sales-topic]', function () {
    $('[data-sales-topic]').removeClass('is-active');
    $(this).addClass('is-active');
    $('#salesTopic-error-msg').text('');
  });

  // Live "what are you trying to accomplish" character counter
  $(document).on('input', '#salesNeeds', function () {
    $('[data-sales-char-count]').text(`${$(this).val().length}/2500 characters`);
  });

  // Submit — validates, then simulates an async submission (no API call yet)
  $form.on('submit', function (e) {
    e.preventDefault();

    const $submitBtn = $('#salesSubmitBtn');
    if ($submitBtn.prop('disabled')) return;

    $form.addClass('was-validated');

    const firstName = $('#salesFirstName').val().trim();
    const lastName = $('#salesLastName').val().trim();
    const email = $('#salesEmail').val().trim();
    const countryCode = $('#salesPhoneCountryCode').val() || '+1';
    const phoneDigits = ($('#salesPhone').data('phoneDigits') || '').slice(0, PHONE_MAX_DIGITS);
    const company = $('#salesCompany').val().trim();
    const role = $('#salesRole').val().trim();
    const businessType = $('#salesBusinessType').val();
    const monthlyVolume = $('#salesVolume').val();
    const $activeTopic = $('[data-sales-topic].is-active');
    const topic = $activeTopic.data('sales-topic') || '';
    const needs = $('#salesNeeds').val().trim();
    const preferredFollowUp = $('#salesFollowUp').val();
    const targetTimeline = $('#salesTimeline').val();

    let isValid = true;
    const setFieldError = (fieldId, msg, $el) => {
      $(`#${fieldId}-error-msg`).text(msg || '');
      if ($el) $el.toggleClass('is-invalid', !!msg);
      if (msg) isValid = false;
    };

    if (!topic) {
      $('#salesTopic-error-msg').text('Choose an option.');
      isValid = false;
    } else {
      $('#salesTopic-error-msg').text('');
    }

    setFieldError('salesFirstName', firstName ? '' : 'First name is required.', $('#salesFirstName'));
    setFieldError('salesLastName', lastName ? '' : 'Last name is required.', $('#salesLastName'));

    if (!email) {
      setFieldError('salesEmail', 'Work email is required.', $('#salesEmail'));
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setFieldError('salesEmail', 'Enter a valid email address (e.g. name@company.com).', $('#salesEmail'));
    } else {
      setFieldError('salesEmail', '', $('#salesEmail'));
    }

    if (phoneDigits) {
      setFieldError(
        'salesPhone',
        phoneDigits.length === PHONE_MAX_DIGITS ? '' : `Enter a valid ${countryCode === '+1' ? 'US' : 'India'} phone number.`,
        $('#salesPhone')
      );
    } else {
      setFieldError('salesPhone', '', $('#salesPhone'));
    }

    setFieldError('salesCompany', company ? '' : 'Company is required.', $('#salesCompany'));

    if (!needs) {
      setFieldError('salesNeeds', 'Tell us what you are trying to accomplish.', $('#salesNeeds'));
    } else if (needs.length < 10) {
      setFieldError('salesNeeds', 'Please provide at least 10 characters describing your needs.', $('#salesNeeds'));
    } else {
      setFieldError('salesNeeds', '', $('#salesNeeds'));
    }

    if (!isValid) return;

    const payload = {
      payloadType: 'SWIREPAY_SALES_ENQUIRY',
      topic,
      firstName,
      lastName,
      email,
      phone: phoneDigits ? `${countryCode}${phoneDigits}` : null,
      company,
      role: role || null,
      businessType,
      monthlyVolume,
      needs,
      preferredFollowUp,
      targetTimeline,
    };

    submitFormPayload($submitBtn, process.env.SALES_TICKET_SUBMIT, payload, 'Enquiry submitted');
  });
}
